const CONSTANTS = {
    ON_METERS_ARE_LOADING: 'meters/ON_METERS_ARE_LOADING',
    ON_METERS_LIST: 'meters/ON_METERS_LIST',
    ON_METER_TYPES_ARE_LOADING: 'meters/ON_METER_TYPES_ARE_LOADING',
    ON_METER_TYPES_LIST: 'meter/ON_METER_TYPES_LIST',
    ON_METER_PURPOSES_LIST: 'meter/ON_METER_PURPOSES_LIST',
    ON_METER_PURPOSES_ARE_LOADING: 'meters/ON_METER_PURPOSES_ARE_LOADING',
    ON_METER_FLAVORS_LIST: 'meter/ON_METER_FLAVORS_LIST',
    ON_METER_FLAVORS_ARE_LOADING: 'meter/ON_METER_FLAVORS_ARE_LOADING'
};

export { CONSTANTS };
